// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductionLogs_page__SISik .ProductionLogs_periodFilterRow__mRwaY {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  margin-bottom: 1rem;
  margin-right: 1rem;
}
.ProductionLogs_page__SISik .ProductionLogs_periodSection__Snqb8 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  position: relative;
}
.ProductionLogs_page__SISik .ProductionLogs_customDateBadge__kqoQJ {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: var(--m-background-subtle-primary, #e9ecef);
  color: var(--m-text, #333);
  border: 1px solid var(--m-border-card-file, #dee2e6);
  border-radius: 6px;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
}
.ProductionLogs_page__SISik .ProductionLogs_customDateBadge__kqoQJ .ProductionLogs_clearBadgeBtn__S\\+u\\+w {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  width: 16px;
  height: 16px;
  cursor: pointer;
  padding: 0;
  color: var(--m-text-light, #6c757d);
}
.ProductionLogs_page__SISik .ProductionLogs_customDateBadge__kqoQJ .ProductionLogs_clearBadgeBtn__S\\+u\\+w:hover {
  color: var(--m-text, #333);
}
.ProductionLogs_page__SISik .ProductionLogs_periodSelector__J3guL {
  display: flex;
  align-items: center;
  gap: 4px;
  background: var(--m-background-subtle-primary, #e9ecef);
  border: 1px solid var(--m-primary-subtle, #dee2e6);
  border-radius: 8px;
  padding: 4px;
}
.ProductionLogs_page__SISik .ProductionLogs_periodSelector__J3guL .ProductionLogs_dayNavigation__3vIcu {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-right: 4px;
  padding-right: 8px;
  border-right: 1px solid var(--m-primary-subtle, #dee2e6);
}
.ProductionLogs_page__SISik .ProductionLogs_periodSelector__J3guL .ProductionLogs_dayNavigation__3vIcu .ProductionLogs_navDayBtn__Ue5-L {
  padding: 6px 10px;
  background: transparent;
  color: var(--m-text-light, #6c757d);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
}
.ProductionLogs_page__SISik .ProductionLogs_periodSelector__J3guL .ProductionLogs_dayNavigation__3vIcu .ProductionLogs_navDayBtn__Ue5-L:hover:not(:disabled) {
  background: var(--m-background-subtle-primary-hovered, #dee2e6);
  color: var(--m-text, #333);
}
.ProductionLogs_page__SISik .ProductionLogs_periodSelector__J3guL .ProductionLogs_dayNavigation__3vIcu .ProductionLogs_navDayBtn__Ue5-L:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.ProductionLogs_page__SISik .ProductionLogs_periodSelector__J3guL .ProductionLogs_dayNavigation__3vIcu .ProductionLogs_selectedDateLabel__\\+zjbZ {
  padding: 6px 12px;
  color: var(--m-text, #333);
  font-size: 13px;
  font-weight: 500;
  min-width: 80px;
  text-align: center;
  white-space: nowrap;
}
.ProductionLogs_page__SISik .ProductionLogs_periodSelector__J3guL .ProductionLogs_periodBtn__ckZAy {
  padding: 8px 16px;
  background: transparent;
  color: var(--m-text-light, #6c757d);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 6px;
}
.ProductionLogs_page__SISik .ProductionLogs_periodSelector__J3guL .ProductionLogs_periodBtn__ckZAy:hover {
  background: var(--m-background-subtle-primary-hovered, #dee2e6);
  color: var(--m-text, #333);
}
.ProductionLogs_page__SISik .ProductionLogs_periodSelector__J3guL .ProductionLogs_periodBtn__ckZAy.ProductionLogs_active__MwLU2 {
  background: var(--m-primary, #0c8479);
  color: white;
  box-shadow: 0 2px 4px rgba(12, 132, 121, 0.2);
}
.ProductionLogs_page__SISik .ProductionLogs_customDateRangePicker__snwgo {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border-card-file, #dee2e6);
  border-radius: var(--m-border-radius-md, 12px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 20px;
  z-index: 1000;
  min-width: 320px;
  max-width: 400px;
}
.ProductionLogs_page__SISik .ProductionLogs_customDateRangePicker__snwgo .ProductionLogs_dateRangeHeader__EIZN\\+ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--m-border-card-file, #dee2e6);
}
.ProductionLogs_page__SISik .ProductionLogs_customDateRangePicker__snwgo .ProductionLogs_dateRangeHeader__EIZN\\+ span {
  font-size: 14px;
  font-weight: 600;
  color: var(--m-text, #333);
}
.ProductionLogs_page__SISik .ProductionLogs_customDateRangePicker__snwgo .ProductionLogs_dateRangeHeader__EIZN\\+ .ProductionLogs_closeDatePicker__EjYmm {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: var(--m-text-light, #6c757d);
}
.ProductionLogs_page__SISik .ProductionLogs_customDateRangePicker__snwgo .ProductionLogs_dateRangeHeader__EIZN\\+ .ProductionLogs_closeDatePicker__EjYmm:hover {
  background: var(--m-background-subtle-primary, #e9ecef);
  color: var(--m-text, #333);
}
.ProductionLogs_page__SISik .ProductionLogs_customDateRangePicker__snwgo .ProductionLogs_dateRangeInputs__sbDO4 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.ProductionLogs_page__SISik .ProductionLogs_customDateRangePicker__snwgo .ProductionLogs_dateRangeInputs__sbDO4 .ProductionLogs_dateInputGroup__BUwYK {
  flex: 1 1;
}
.ProductionLogs_page__SISik .ProductionLogs_customDateRangePicker__snwgo .ProductionLogs_dateRangeInputs__sbDO4 .ProductionLogs_dateRangeActions__BBH-y {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}
.ProductionLogs_page__SISik .ProductionLogs_customDateRangePicker__snwgo .ProductionLogs_dateRangeInputs__sbDO4 .ProductionLogs_dateRangeActions__BBH-y .ProductionLogs_applyDateRangeBtn__ricyB {
  flex: 1 1;
  padding: 10px 20px;
  background: var(--m-background-primary, #0c8479);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}
.ProductionLogs_page__SISik .ProductionLogs_customDateRangePicker__snwgo .ProductionLogs_dateRangeInputs__sbDO4 .ProductionLogs_dateRangeActions__BBH-y .ProductionLogs_applyDateRangeBtn__ricyB:hover:not(:disabled) {
  opacity: 0.9;
}
.ProductionLogs_page__SISik .ProductionLogs_customDateRangePicker__snwgo .ProductionLogs_dateRangeInputs__sbDO4 .ProductionLogs_dateRangeActions__BBH-y .ProductionLogs_applyDateRangeBtn__ricyB:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: var(--m-subtle-xbolder, #adb5bd);
}
.ProductionLogs_page__SISik .ProductionLogs_customDateRangePicker__snwgo .ProductionLogs_dateRangeInputs__sbDO4 .ProductionLogs_dateRangeActions__BBH-y .ProductionLogs_clearDateRangeBtn__kSJZD {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 16px;
  background: transparent;
  color: var(--m-text-light, #6c757d);
  border: 1px solid var(--m-border-card-file, #dee2e6);
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}
.ProductionLogs_page__SISik .ProductionLogs_customDateRangePicker__snwgo .ProductionLogs_dateRangeInputs__sbDO4 .ProductionLogs_dateRangeActions__BBH-y .ProductionLogs_clearDateRangeBtn__kSJZD:hover {
  background: var(--m-background-subtle-primary, #e9ecef);
  color: var(--m-text, #333);
}
.ProductionLogs_page__SISik .ProductionLogs_kpiRow__YxAgz {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.ProductionLogs_page__SISik .ProductionLogs_kpiCard__X2b\\+N {
  flex: 1 1;
  min-width: 200px;
}
.ProductionLogs_page__SISik .ProductionLogs_filterToggle__K0fFq {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  background: var(--m-card-background-color, #f8f9fa);
  border-radius: var(--m-border-radius-md, 8px);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.2s;
}
.ProductionLogs_page__SISik .ProductionLogs_filterToggle__K0fFq:hover {
  background: var(--m-input-background-color, #e9ecef);
}
.ProductionLogs_page__SISik .ProductionLogs_filterPanel__FkCJK {
  padding: 1rem 0 0;
  border-top: 1px solid var(--m-border-color, #dee2e6);
  margin-top: 0.5rem;
}
.ProductionLogs_page__SISik .ProductionLogs_dayGroups__HDsEL {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.ProductionLogs_page__SISik .ProductionLogs_dayGroup__G5EMy {
  border: 1px solid var(--m-border-color, #dee2e6);
  border-radius: var(--m-border-radius-md, 8px);
  overflow: hidden;
}
.ProductionLogs_page__SISik .ProductionLogs_dayHeader__3yM5U {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background: var(--m-card-background-color, #f8f9fa);
  border-bottom: 1px solid var(--m-border-color, #dee2e6);
  font-size: 0.95rem;
}
.ProductionLogs_page__SISik .ProductionLogs_dayDate__ZChua {
  font-weight: 600;
  color: var(--m-text, #333);
}
.ProductionLogs_page__SISik .ProductionLogs_dayTotal__l7fR\\+ {
  color: var(--m-text-light, #6c757d);
  font-size: 0.9rem;
}
.ProductionLogs_page__SISik .ProductionLogs_dayGroup__G5EMy .ProductionLogs_table-wrapper__Fo7-7,
.ProductionLogs_page__SISik .ProductionLogs_dayGroup__G5EMy table {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/ProductionLogs/ProductionLogs.module.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,uDAAA;EACA,0BAAA;EACA,oDAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAFJ;AAII;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,mCAAA;AAFN;AAIM;EACE,0BAAA;AAFR;AAOE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,uDAAA;EACA,kDAAA;EACA,kBAAA;EACA,YAAA;AALJ;AAOI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,wDAAA;AALN;AAOM;EACE,iBAAA;EACA,uBAAA;EACA,mCAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;AALR;AAOQ;EACE,+DAAA;EACA,0BAAA;AALV;AAQQ;EACE,YAAA;EACA,mBAAA;AANV;AAUM;EACE,iBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AARR;AAYI;EACE,iBAAA;EACA,uBAAA;EACA,mCAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAVN;AAYM;EACE,+DAAA;EACA,0BAAA;AAVR;AAaM;EACE,qCAAA;EACA,YAAA;EACA,6CAAA;AAXR;AAgBE;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,gDAAA;EACA,oDAAA;EACA,8CAAA;EACA,0CAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAdJ;AAgBI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,2DAAA;AAdN;AAgBM;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;AAdR;AAiBM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,mCAAA;AAfR;AAiBQ;EACE,uDAAA;EACA,0BAAA;AAfV;AAoBI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAlBN;AAoBM;EACE,SAAA;AAlBR;AAqBM;EACE,aAAA;EACA,QAAA;EACA,eAAA;AAnBR;AAqBQ;EACE,SAAA;EACA,kBAAA;EACA,gDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAnBV;AAqBU;EACE,YAAA;AAnBZ;AAsBU;EACE,YAAA;EACA,mBAAA;EACA,4CAAA;AApBZ;AAwBQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,uBAAA;EACA,mCAAA;EACA,oDAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAtBV;AAwBU;EACE,uDAAA;EACA,0BAAA;AAtBZ;AA6BE;EACE,aAAA;EACA,eAAA;EACA,SAAA;AA3BJ;AA8BE;EACE,SAAA;EACA,gBAAA;AA5BJ;AA+BE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,mDAAA;EACA,6CAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,2BAAA;AA7BJ;AA+BI;EACE,oDAAA;AA7BN;AAiCE;EACE,iBAAA;EACA,oDAAA;EACA,kBAAA;AA/BJ;AAkCE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAhCJ;AAmCE;EACE,gDAAA;EACA,6CAAA;EACA,gBAAA;AAjCJ;AAoCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,mDAAA;EACA,uDAAA;EACA,kBAAA;AAlCJ;AAqCE;EACE,gBAAA;EACA,0BAAA;AAnCJ;AAsCE;EACE,mCAAA;EACA,iBAAA;AApCJ;AAuCE;;EAEE,gBAAA;AArCJ","sourcesContent":[".page {\n  .periodFilterRow {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 1rem;\n    margin-bottom: 1rem;\n    margin-right: 1rem;\n  }\n\n  .periodSection {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 12px;\n    position: relative;\n  }\n\n  .customDateBadge {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 10px;\n    background: var(--m-background-subtle-primary, #e9ecef);\n    color: var(--m-text, #333);\n    border: 1px solid var(--m-border-card-file, #dee2e6);\n    border-radius: 6px;\n    font-size: 12px;\n    font-weight: 400;\n    white-space: nowrap;\n\n    .clearBadgeBtn {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: transparent;\n      border: none;\n      width: 16px;\n      height: 16px;\n      cursor: pointer;\n      padding: 0;\n      color: var(--m-text-light, #6c757d);\n\n      &:hover {\n        color: var(--m-text, #333);\n      }\n    }\n  }\n\n  .periodSelector {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    background: var(--m-background-subtle-primary, #e9ecef);\n    border: 1px solid var(--m-primary-subtle, #dee2e6);\n    border-radius: 8px;\n    padding: 4px;\n\n    .dayNavigation {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      margin-right: 4px;\n      padding-right: 8px;\n      border-right: 1px solid var(--m-primary-subtle, #dee2e6);\n\n      .navDayBtn {\n        padding: 6px 10px;\n        background: transparent;\n        color: var(--m-text-light, #6c757d);\n        border: none;\n        border-radius: 6px;\n        cursor: pointer;\n        font-size: 13px;\n        font-weight: 500;\n        transition: all 0.2s ease;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        min-width: 32px;\n        height: 32px;\n\n        &:hover:not(:disabled) {\n          background: var(--m-background-subtle-primary-hovered, #dee2e6);\n          color: var(--m-text, #333);\n        }\n\n        &:disabled {\n          opacity: 0.4;\n          cursor: not-allowed;\n        }\n      }\n\n      .selectedDateLabel {\n        padding: 6px 12px;\n        color: var(--m-text, #333);\n        font-size: 13px;\n        font-weight: 500;\n        min-width: 80px;\n        text-align: center;\n        white-space: nowrap;\n      }\n    }\n\n    .periodBtn {\n      padding: 8px 16px;\n      background: transparent;\n      color: var(--m-text-light, #6c757d);\n      border: none;\n      border-radius: 6px;\n      cursor: pointer;\n      font-size: 13px;\n      font-weight: 500;\n      transition: all 0.2s ease;\n      white-space: nowrap;\n      display: flex;\n      align-items: center;\n      gap: 6px;\n\n      &:hover {\n        background: var(--m-background-subtle-primary-hovered, #dee2e6);\n        color: var(--m-text, #333);\n      }\n\n      &.active {\n        background: var(--m-primary, #0c8479);\n        color: white;\n        box-shadow: 0 2px 4px rgba(12, 132, 121, 0.2);\n      }\n    }\n  }\n\n  .customDateRangePicker {\n    position: absolute;\n    top: calc(100% + 8px);\n    left: 0;\n    background: var(--m-card-background-color, #fff);\n    border: 1px solid var(--m-border-card-file, #dee2e6);\n    border-radius: var(--m-border-radius-md, 12px);\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n    padding: 20px;\n    z-index: 1000;\n    min-width: 320px;\n    max-width: 400px;\n\n    .dateRangeHeader {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 16px;\n      padding-bottom: 12px;\n      border-bottom: 1px solid var(--m-border-card-file, #dee2e6);\n\n      span {\n        font-size: 14px;\n        font-weight: 600;\n        color: var(--m-text, #333);\n      }\n\n      .closeDatePicker {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 28px;\n        height: 28px;\n        padding: 0;\n        background: transparent;\n        border: none;\n        border-radius: 6px;\n        cursor: pointer;\n        color: var(--m-text-light, #6c757d);\n\n        &:hover {\n          background: var(--m-background-subtle-primary, #e9ecef);\n          color: var(--m-text, #333);\n        }\n      }\n    }\n\n    .dateRangeInputs {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n\n      .dateInputGroup {\n        flex: 1;\n      }\n\n      .dateRangeActions {\n        display: flex;\n        gap: 8px;\n        margin-top: 8px;\n\n        .applyDateRangeBtn {\n          flex: 1;\n          padding: 10px 20px;\n          background: var(--m-background-primary, #0c8479);\n          color: white;\n          border: none;\n          border-radius: 6px;\n          cursor: pointer;\n          font-size: 14px;\n          font-weight: 500;\n\n          &:hover:not(:disabled) {\n            opacity: 0.9;\n          }\n\n          &:disabled {\n            opacity: 0.5;\n            cursor: not-allowed;\n            background: var(--m-subtle-xbolder, #adb5bd);\n          }\n        }\n\n        .clearDateRangeBtn {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          gap: 6px;\n          padding: 10px 16px;\n          background: transparent;\n          color: var(--m-text-light, #6c757d);\n          border: 1px solid var(--m-border-card-file, #dee2e6);\n          border-radius: 6px;\n          cursor: pointer;\n          font-size: 14px;\n\n          &:hover {\n            background: var(--m-background-subtle-primary, #e9ecef);\n            color: var(--m-text, #333);\n          }\n        }\n      }\n    }\n  }\n\n  .kpiRow {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n  }\n\n  .kpiCard {\n    flex: 1;\n    min-width: 200px;\n  }\n\n  .filterToggle {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.75rem 1rem;\n    background: var(--m-card-background-color, #f8f9fa);\n    border-radius: var(--m-border-radius-md, 8px);\n    cursor: pointer;\n    user-select: none;\n    transition: background 0.2s;\n\n    &:hover {\n      background: var(--m-input-background-color, #e9ecef);\n    }\n  }\n\n  .filterPanel {\n    padding: 1rem 0 0;\n    border-top: 1px solid var(--m-border-color, #dee2e6);\n    margin-top: 0.5rem;\n  }\n\n  .dayGroups {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n\n  .dayGroup {\n    border: 1px solid var(--m-border-color, #dee2e6);\n    border-radius: var(--m-border-radius-md, 8px);\n    overflow: hidden;\n  }\n\n  .dayHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.75rem 1rem;\n    background: var(--m-card-background-color, #f8f9fa);\n    border-bottom: 1px solid var(--m-border-color, #dee2e6);\n    font-size: 0.95rem;\n  }\n\n  .dayDate {\n    font-weight: 600;\n    color: var(--m-text, #333);\n  }\n\n  .dayTotal {\n    color: var(--m-text-light, #6c757d);\n    font-size: 0.9rem;\n  }\n\n  .dayGroup .table-wrapper,\n  .dayGroup table {\n    margin-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `ProductionLogs_page__SISik`,
	"periodFilterRow": `ProductionLogs_periodFilterRow__mRwaY`,
	"periodSection": `ProductionLogs_periodSection__Snqb8`,
	"customDateBadge": `ProductionLogs_customDateBadge__kqoQJ`,
	"clearBadgeBtn": `ProductionLogs_clearBadgeBtn__S+u+w`,
	"periodSelector": `ProductionLogs_periodSelector__J3guL`,
	"dayNavigation": `ProductionLogs_dayNavigation__3vIcu`,
	"navDayBtn": `ProductionLogs_navDayBtn__Ue5-L`,
	"selectedDateLabel": `ProductionLogs_selectedDateLabel__+zjbZ`,
	"periodBtn": `ProductionLogs_periodBtn__ckZAy`,
	"active": `ProductionLogs_active__MwLU2`,
	"customDateRangePicker": `ProductionLogs_customDateRangePicker__snwgo`,
	"dateRangeHeader": `ProductionLogs_dateRangeHeader__EIZN+`,
	"closeDatePicker": `ProductionLogs_closeDatePicker__EjYmm`,
	"dateRangeInputs": `ProductionLogs_dateRangeInputs__sbDO4`,
	"dateInputGroup": `ProductionLogs_dateInputGroup__BUwYK`,
	"dateRangeActions": `ProductionLogs_dateRangeActions__BBH-y`,
	"applyDateRangeBtn": `ProductionLogs_applyDateRangeBtn__ricyB`,
	"clearDateRangeBtn": `ProductionLogs_clearDateRangeBtn__kSJZD`,
	"kpiRow": `ProductionLogs_kpiRow__YxAgz`,
	"kpiCard": `ProductionLogs_kpiCard__X2b+N`,
	"filterToggle": `ProductionLogs_filterToggle__K0fFq`,
	"filterPanel": `ProductionLogs_filterPanel__FkCJK`,
	"dayGroups": `ProductionLogs_dayGroups__HDsEL`,
	"dayGroup": `ProductionLogs_dayGroup__G5EMy`,
	"dayHeader": `ProductionLogs_dayHeader__3yM5U`,
	"dayDate": `ProductionLogs_dayDate__ZChua`,
	"dayTotal": `ProductionLogs_dayTotal__l7fR+`,
	"table-wrapper": `ProductionLogs_table-wrapper__Fo7-7`
};
export default ___CSS_LOADER_EXPORT___;
